export default __webpack_public_path__ + "arrow-left-circle-thin.1cc8be924fc18cf2b7762f917ce975ab.svg";